import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DealershipInfoCard = ({ dealership, onContact }) => {
  const handleCall = (phone) => {
    window.open(`tel:${phone}`, '_self');
  };

  const handleEmail = (email) => {
    window.open(`mailto:${email}`, '_self');
  };

  const handleDirections = () => {
    const address = `${dealership?.address?.street}, ${dealership?.address?.zipCode} ${dealership?.address?.city}`;
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary flex items-center gap-2">
          <Icon name="Building2" size={20} />
          Autohaus Information
        </h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onContact}
          iconName="MessageSquare"
          iconPosition="left"
        >
          Kontakt
        </Button>
      </div>
      <div className="space-y-4">
        {/* Dealership Name and Brand */}
        <div>
          <div className="flex items-center gap-3 mb-2">
            <h4 className="text-xl font-semibold text-text-primary">{dealership?.name}</h4>
            <span className="px-2 py-1 bg-primary text-primary-foreground text-xs font-medium rounded">
              {dealership?.brand}
            </span>
          </div>
          <p className="text-text-secondary">{dealership?.description}</p>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-3">
            <div>
              <label className="text-sm font-medium text-text-secondary">Ansprechpartner</label>
              <div className="mt-1 flex items-center gap-2">
                <Icon name="User" size={16} className="text-text-secondary" />
                <span className="text-text-primary">{dealership?.contactPerson}</span>
              </div>
            </div>
            
            <div>
              <label className="text-sm font-medium text-text-secondary">Telefon</label>
              <div className="mt-1 flex items-center gap-2">
                <Icon name="Phone" size={16} className="text-text-secondary" />
                <button
                  onClick={() => handleCall(dealership?.phone)}
                  className="text-primary hover:underline"
                >
                  {dealership?.phone}
                </button>
              </div>
            </div>
            
            <div>
              <label className="text-sm font-medium text-text-secondary">E-Mail</label>
              <div className="mt-1 flex items-center gap-2">
                <Icon name="Mail" size={16} className="text-text-secondary" />
                <button
                  onClick={() => handleEmail(dealership?.email)}
                  className="text-primary hover:underline"
                >
                  {dealership?.email}
                </button>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <div>
              <label className="text-sm font-medium text-text-secondary">Adresse</label>
              <div className="mt-1 flex items-start gap-2">
                <Icon name="MapPin" size={16} className="text-text-secondary mt-0.5" />
                <div className="text-text-primary">
                  <div>{dealership?.address?.street}</div>
                  <div>{dealership?.address?.zipCode} {dealership?.address?.city}</div>
                </div>
              </div>
            </div>
            
            <Button
              variant="outline"
              size="sm"
              onClick={handleDirections}
              iconName="Navigation"
              iconPosition="left"
              className="w-full"
            >
              Route anzeigen
            </Button>
          </div>
        </div>

        {/* Business Information */}
        <div className="pt-4 border-t border-border">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <div>
              <label className="text-text-secondary">USt-IdNr.</label>
              <div className="text-text-primary font-mono">{dealership?.vatId}</div>
            </div>
            <div>
              <label className="text-text-secondary">Zahlungsziel</label>
              <div className="text-text-primary">{dealership?.paymentTerms} Tage</div>
            </div>
            <div>
              <label className="text-text-secondary">Status</label>
              <div className="flex items-center gap-1">
                <div className={`w-2 h-2 rounded-full ${dealership?.isActive ? 'bg-success' : 'bg-error'}`} />
                <span className={dealership?.isActive ? 'text-success' : 'text-error'}>
                  {dealership?.isActive ? 'Aktiv' : 'Inaktiv'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealershipInfoCard;